import type { SxProps, Theme } from '@mui/material'
import { useShowBottomNav } from '@hooks/useShowBottomNav'
import { useShowMiniSessionBar } from '@hooks/useShowMiniSessionBar'
import { useShellOverlayMetrics } from './shellOverlayMetrics'
import { shellFixedBottomOffsetCss } from './shellOverlayStack'

/** Snackbar/alert surface: never force a desktop minWidth on narrow viewports. */
export const APP_SNACKBAR_CONTENT_SX: SxProps<Theme> = {
  width: '100%',
  minWidth: 0,
  maxWidth: { xs: 'calc(100vw - 32px)', sm: 480 },
}

export function useAppSnackbarAnchorSx(extraBottomPx = 0): SxProps<Theme> {
  const showBottomNav = useShowBottomNav()
  const showMiniBar = useShowMiniSessionBar()
  const { bannerHeightPx, keyboardInsetPx } = useShellOverlayMetrics()
  const bottom = shellFixedBottomOffsetCss(
    {
      bottomNav: showBottomNav,
      miniSessionBar: showMiniBar,
    },
    {
      extraPx: extraBottomPx + bannerHeightPx,
      keyboardInsetPx,
    },
  )
  return {
    bottom,
    left: { xs: 8, sm: 24 },
    right: { xs: 8, sm: 24 },
  }
}
